import styled from 'styled-components';
import {BGImageCenter, LIGHT_BLUE4, mobileMedia} from '../../globalVariables/GlobalVariables';
import {popUpTop, popTitle, children} from '../newPopup/topPopup/TopPopup.css';
import {Close} from '../close/Close.css';
import {popUpBody} from '../newPopup/mobilePopup/MobilePopup.css';
import {dFlex, flexColumn, justifyCenter, justifyEnd} from '../../globalVariables/GlobalFlex';
import {bottom} from '../popupAfterAdvertise/privateEvent/BottomSection.css';
import {arrowDark} from '../../assets/symbols/symbols/Symbols.css';

export const wrapper = styled.div<{$back: boolean}>`
    ${popUpTop}{
        background-color: ${LIGHT_BLUE4};
        border-radius: 5px 5px 0 0;
        height: 150px;
    }
    ${Close}{
        height: 60px;
        width: 60px;
        background-size: 14px;
        ${p=>p.$back &&
            `${BGImageCenter(arrowDark, '20px')}
            &:hover{
                transform: unset;
            }`
        }
    }
    ${popTitle}{
        width: 0;
    }
    ${popUpBody}{
        width: 681px;
        height: 611px;
        ${mobileMedia}{
            width: 100%;
            height: 100%;
        }
    }
    ${children}{
        width: 100%;
    }
`;

export const main = styled.div`
    height: 100%;
    width: 100%;
    ${dFlex};
    ${flexColumn};
    ${justifyCenter};
`;
export const icon = styled.div<{$icon: string}>`
    ${p=>BGImageCenter(p.$icon, 'contain')};
    position: absolute;
    inset-inline-end: 35px;
    bottom: -60px;
    height: 180px;
    width: 240px;
    ${mobileMedia}{
        height: 120px;
        width: 150px;
        inset-block-start: -60px;
        inset-inline-end: calc(50% - 75px);
    }
`;
export const title = styled.div`
    font-size: 20px;
    font-weight: 800;
    ${mobileMedia}{
        font-size: 18px;
        margin-top: 30px;
    }
    margin-bottom: 10px;
`;
export const text = styled.div`
    font-size: 16px;
    font-weight: 400;
    ${mobileMedia}{
        font-size: 14px;
    }
`;
export const btnIcon=styled.div<{$icon: string}>`
    height: 15px;
    width: 15px;
    margin-inline-end: 5px;
     ${p=>BGImageCenter(p.$icon)};
    &.LOADING, &.FAILED{
        background-image: none;
    }
`;

export const buttonContainer = styled(bottom)`
    ${justifyEnd};
`;